// src/modules/competition/components/MinisterCard/index.js
import { Card, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';

const MinisterCard = ({ competitor }) => {
    return (
        <Card className="mb-3 h-100">
            <Card.Header as="h5">Current Minister</Card.Header>
            <Card.Body className="text-center">
                {competitor ? (
                    <>
                        <Image
                            src={competitor.profilePicture || '/default-avatar.png'}
                            roundedCircle
                            style={{ width: '100px', height: '100px', objectFit: 'cover', marginBottom: '1rem' }}
                        />
                        <Card.Title>{competitor.firstName} 🥇</Card.Title>
                        <Card.Text>Points Current Period: {competitor.totalPoints?.toFixed(2)}</Card.Text>
                        <Card.Text>Points Last Round: {competitor.lastRoundPoints?.toFixed(2) || 'N/A'}</Card.Text>
                    </>
                ) : (
                    <Card.Text>There is no minister</Card.Text>
                )}
            </Card.Body>
        </Card>
    );
};

MinisterCard.propTypes = {
    competitor: PropTypes.shape({
        firstName: PropTypes.string,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number,
        lastRoundPoints: PropTypes.number
    })
};

MinisterCard.defaultProps = {
    competitor: undefined
};

export default MinisterCard;